export default __webpack_public_path__ + "static/media/pair-white.128750b7.svg";